import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { Suggest } from './Suggest/Suggest'
import { useResults } from '../../../../../../../Packages/Plugins/TechDivision.SearchPlugin/Resources/Private/JavaScript/Hooks/useResults'
import { TagFilters } from './components/TagFilters'
import { Results } from './components/Results'

const component = 'search'

/**
 * Search
 * @param config
 * @returns {JSX.Element}
 * @constructor
 */
export function Search({ config }) {
    const [page, setPage] = useState(0)
    const [q, setQ] = useState('')
    const [results, setResults] = useState([])
    const [clearResults, setClearResults] = useState(false)
    const [tagFilters, setTagFilters] = useState([])
    const [activeTagFilter, setActiveTagFilter] = useState('')

    const addResults = (newResults) => {
        if (clearResults) {
            setResults([])
            setClearResults(false)
        }
        setResults((results) => [...results, ...newResults])
    }
    const handleActiveTagFilter = (filter) => {
        if (activeTagFilter !== filter) {
            setClearResults(true)
            setActiveTagFilter(filter)
            setPage(0)

            // Change the deep link
            window.history.replaceState(
                null,
                '',
                window.location.pathname + '?q=' + q + (filter ? '&tag=' : '') + filter
            )
        }
    }
    const [count, setCount] = useState(0)
    const [unfilteredCount, setUnfilteredCount] = useState(0)
    const [isLoading, setLoading] = useState(false)
    const { fetchResults } = useResults(config.apiUrl)

    useEffect(() => {
        const fetchData = async () => {
            const apiData = await fetchResults(q, page, activeTagFilter)
            setLoading(false)
            addResults(apiData.results)
            setCount(apiData.count)
            setUnfilteredCount(apiData.unfilteredCount)
            setTagFilters(apiData.tagFilterResults)
        }

        if (q.length) {
            setLoading(true)
            fetchData().catch((error) => {})
        }
    }, [q, page, activeTagFilter])

    useEffect(() => {
        if (config.queryParam !== undefined) {
            setQ(config.queryParam)
        }
        if (config.tagParam !== undefined) {
            setActiveTagFilter(config.tagParam)
        }
    }, [])

    if (isLoading && !results.length) {
        return <CircularProgress className={`${component}__circular-progress`} />
    }

    // page has to be incremented by 1 as it is a 0-based index, but we have to calculate with a 1-based number
    const areItemsLeftToLoad = count > (page + 1) * config.resultsPerPage

    return (
        <>
            <div className={'search__layout--left'}>
                <Suggest config={config} />
                {results.length && count !== 0 ? (
                    <TagFilters
                        filters={tagFilters}
                        handleFilterCallback={handleActiveTagFilter}
                        activeFilter={activeTagFilter}
                        resultCount={unfilteredCount}
                        allLabel={config.labelAll}
                    />
                ) : null}
            </div>
            <div className={'search__layout--right'}>
                {results.length && count !== 0 ? (
                    <>
                        {!clearResults ? <Results readMoreLabel={config.labelReadMore} results={results} /> : null}
                        {isLoading ? <CircularProgress className={`${component}__circular-progress`} /> : null}
                        {!clearResults && areItemsLeftToLoad ? (
                            <button
                                className={`${component}__load-more btn`}
                                onClick={() => {
                                    setPage(page + 1)
                                }}
                            >
                                {config.labelLoadMore}
                            </button>
                        ) : null}
                    </>
                ) : (
                    <p className={`${component}__no-results`}>{config.labelNoResults}</p>
                )}
            </div>
        </>
    )
}
